import React, { useState, useEffect, useRef } from 'react';
import './Dropdown.css';
import LoadingOverlay from '../components/LoadingOverlay';
import FormularioGarantia from '../Formulario/FormularioGarantia';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';
import { ehPrincipal, textoResponsavelCard } from '../utils/responsavelPrincipal';
import PopupHorasReais, { salvarHorasReais } from '../components/PopupHorasReais';

// Helper: listens for MobileFooter generic + event
function MobileAddListener({ onOpen }) {
  useEffect(() => {
    window.addEventListener('open-mobile-add-popup', onOpen);
    return () => window.removeEventListener('open-mobile-add-popup', onOpen);
  }, [onOpen]);
  return null;
}

function GarantiaDropdown() {
    const [garantias, setGarantias] = useState([]);
    const [novaGarantiaAberta, setNovaGarantiaAberta] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dadosEdicao, setDadosEdicao] = useState(null);
    const [modoEdicao, setModoEdicao] = useState(false);

    // Estados para carregar dados relacionados
    const [producoes, setProducoes] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [contratos, setContratos] = useState([]);
    const [pessoas, setPessoas] = useState([]);

    // Filtros
    const [filtro, setFiltro] = useState('');
    const [tipoFiltro, setTipoFiltro] = useState('idGarantia');
    const [dropdownAberto, setDropdownAberto] = useState(false);

    // Estados do Calendário
    const [calendarioAberto, setCalendarioAberto] = useState(false);
    const [mesAtual, setMesAtual] = useState(new Date());
    const [garantiasPorData, setGarantiasPorData] = useState({});
    const [datasSelecionadas, setDatasSelecionadas] = useState(null);
    const [mostrarGarantiasDoDia, setMostrarGarantiasDoDia] = useState(false);
    const [garantiasDoDia, setGarantiasDoDia] = useState([]);

    // Modal de seleção de produção
    const [selecionarProducaoAberto, setSelecionarProducaoAberto] = useState(false);
    const [producoesFiltradas, setProducoesFiltradas] = useState([]);
    // Garantia e manutenção só para projeto finalizado e dentro do prazo de garantia (conta da aprovação do cliente)
    const producoesFinalizadas = producoesFiltradas.filter(p => /conclu|finaliz/i.test(p.Status || p.status || p.StatusNome || p.statusNome || '') && p.dentroDaGarantia !== false);
    const [filtroProducao, setFiltroProducao] = useState('');
    const [tipoFiltroProducao, setTipoFiltroProducao] = useState('todos');
    const [loadingProducoes, setLoadingProducoes] = useState(false);
    const [producaoSelecionada, setProducaoSelecionada] = useState(null);

    // Estados para responsáveis da garantia
    const [responsaveis, setResponsaveis] = useState([]);
    // { garantiaId: [responsáveis] }
    const [responsaveisPorGarantia, setResponsaveisPorGarantia] = useState({});
    // Concluir garantia: pop-up das horas reais (dados do formulário esperando as horas) e as horas informadas
    const [conclusaoPendente, setConclusaoPendente] = useState(null);
    const horasReaisConclusaoRef = useRef(null);
    const [responsaveisGarantia, setResponsaveisGarantia] = useState([]);
    const [adicionarRespAberto, setAdicionarRespAberto] = useState(false);
    const [novoResponsavel, setNovoResponsavel] = useState({ responsavelId: '', horasPrevistas: '', horasReais: '' });
    const [novoPessoaAberto, setNovoPessoaAberto] = useState(false);
    const [novaPessoa, setNovaPessoa] = useState({ nome: '', custoHora: '' });

    // Ref para FormularioMateriaPrima
    const refFormularioMateriaPrima = useRef(null);

    const opcoesFiltro = [
        { label: 'ID Garantia', value: 'idGarantia' },
        { label: 'ID Projeto', value: 'idProducao' },
        { label: 'ID Cliente', value: 'idCliente' },
        { label: 'ID Contrato', value: 'idContrato' },
        { label: 'Status', value: 'status' },
        { label: 'Por Data', value: 'data' }
    ];

    // Status disponíveis para garantia
    const statusOpcoes = [
        'Solicitada',
        'Em Análise',
        'Aprovada',
        'Em Andamento',
        'Concluída',
        'Recusada',
        'Cancelada'
    ];

    // URLs do backend com fallback
    const BASE_URLS = [BASE_URL];

    const BASE_URLS_PRODUCAO = [
        `${BASE_URL}/Producoes`,
        `${BASE_URL}/Producoes`,
        '/api/Producoes'
    ];

    const BASE_URLS_CLIENTE = [
        `${BASE_URL}/Cliente`,
        `${BASE_URL}/Cliente`,
        '/api/Cliente'
    ];

    const BASE_URLS_CONTRATO = [
        `${BASE_URL}/Contrato`,
        `${BASE_URL}/Contrato`,
        '/api/Contrato'
    ];

    const BASE_URLS_PESSOA = [
        `${BASE_URL}/Pessoas`,
        `${BASE_URL}/Pessoas`,
        '/api/Pessoas'
    ];

    const BASE_URLS_RESPONSAVEIS = [
        `${BASE_URL}/Responsaveis`,
        `${BASE_URL}/Responsaveis`,
        '/api/Responsaveis'
    ];

    // BASE_URLS_HORAS removido - horas agora são incluídas no modelo Responsaveis
    // Função para fazer chamadas à API com fallback
    const apiCall = async (urls, endpoint = '', method = 'GET', data = null) => {
        let lastError;
        for (const baseUrl of urls) {
            try {
                const url = endpoint ? `${baseUrl}/${endpoint}` : baseUrl;
                console.log(`Tentando ${method} ${url}`);
                const config = {
                    method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                };
                const token = getAuthToken();
                if (token) config.headers['Authorization'] = `Bearer ${token}`;
                if (data && method !== 'GET') {
                    config.body = JSON.stringify(data);
                }
                const response = await fetch(url, config);
                if (!response.ok) {
                    throw new Error(`Erro ${response.status}: ${response.statusText}`);
                }
                
                // Verificar se há conteúdo na resposta
                const contentLength = response.headers.get('content-length');
                if (contentLength === '0' || response.status === 204) {
                    console.log(`✅ Sucesso ${method} ${url} (sem conteúdo)`);
                    return null;
                }
                
                const result = await response.json();
                console.log(`✅ Sucesso ${method} ${url}`);
                return result;
            } catch (error) {
                console.log(`❌ Erro ${method} ${baseUrl}${endpoint ? '/' + endpoint : ''}:`, error.message);
                lastError = error;
                continue;
            }
        }
        throw lastError;
    };

    // Carregar dados ao montar o componente
    useEffect(() => {
        fetchGarantias();
        fetchProducoes();
        fetchClientes();
        fetchContratos();
        fetchPessoas();
        fetchResponsaveis();
    }, []);

    useEffect(() => {
        window.dispatchEvent(new CustomEvent('garantia-popup-state', {
            detail: { formularioAberto: novaGarantiaAberta }
        }));
    }, [novaGarantiaAberta]);

    useEffect(() => {
        const handler = () => {
            setNovaGarantiaAberta(false);
            setModoEdicao(false);
            setDadosEdicao(null);
            setDropdownAberto(false);
            setCalendarioAberto(false);
            setMostrarGarantiasDoDia(false);
            setSelecionarProducaoAberto(false);
            setAdicionarRespAberto(false);
            setNovoPessoaAberto(false);
            setProducaoSelecionada(null);
        };
        window.addEventListener('garantia-fechar-todos-popups', handler);
        return () => window.removeEventListener('garantia-fechar-todos-popups', handler);
    }, []);

    const fetchGarantias = async () => {
        try {
            setLoading(true);
            console.log('🛡️ Carregando garantias...');
            const data = await apiCall(BASE_URLS);
            setGarantias(Array.isArray(data) ? data : []);
            console.log('✅ Garantias carregadas:', data);
        } catch (error) {
            console.error('❌ Erro ao carregar garantias:', error);
            setGarantias([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchProducoes = async () => {
        try {
            const data = await apiCall(BASE_URLS_PRODUCAO);
            const arr = Array.isArray(data) ? data : [];
            setProducoes(arr);
            setProducoesFiltradas(arr);
        } catch (error) {
            console.error('❌ Erro ao carregar projetos:', error);
            setProducoes([]);
            setProducoesFiltradas([]);
        }
    };

    const fetchClientes = async () => {
        try {
            const data = await apiCall(BASE_URLS_CLIENTE);
            setClientes(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('❌ Erro ao carregar clientes:', error);
            setClientes([]);
        }
    };

    const fetchContratos = async () => {
        try {
            const data = await apiCall(BASE_URLS_CONTRATO);
            setContratos(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('❌ Erro ao carregar contratos:', error);
            setContratos([]);
        }
    };

    const fetchPessoas = async () => {
        try {
            const data = await apiCall(BASE_URLS_PESSOA);
            setPessoas(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('❌ Erro ao carregar pessoas:', error);
            setPessoas([]);
        }
    };

    const fetchResponsaveis = async () => {
        try {
            const data = await apiCall(BASE_URLS_RESPONSAVEIS);
            const arr = Array.isArray(data) ? data : [];
            // Responsáveis de cada garantia (para o card: o principal, ou "N responsáveis")
            const porGarantia = {};
            arr.forEach(r => {
                const gid = r.garantiaId ?? r.GarantiaId;
                if (gid) (porGarantia[gid] = porGarantia[gid] || []).push(r);
            });
            setResponsaveisPorGarantia(porGarantia);
            // Filtrar apenas responsáveis disponíveis (sem vínculo ativo)
            const disponiveis = arr.filter(r =>
                (!r.tarefasId || r.tarefasId === 0) &&
                (!r.producaoId || r.producaoId === 0) &&
                (!r.montagemId || r.montagemId === 0) &&
                (!r.entregaId || r.entregaId === 0) &&
                (!r.manutencaoId || r.manutencaoId === 0) &&
                (!r.garantiaId || r.garantiaId === 0)
            );
            setResponsaveis(disponiveis);
        } catch (error) {
            console.error('❌ Erro ao carregar responsáveis:', error);
            setResponsaveis([]);
        }
    };

    // Buscar garantia por ID para edição
    const fetchGarantiaPorId = async (id) => {
        horasReaisConclusaoRef.current = null;
        try {
            console.log('🔍 Buscando garantia por ID:', id);
            const garantia = await apiCall(BASE_URLS, `${id}`);
            setDadosEdicao(garantia);
            setModoEdicao(true);
            // Buscar responsáveis vinculados e também a lista de responsáveis disponíveis
            await fetchResponsaveisPorGarantia(id);
            await fetchResponsaveis();
            setNovaGarantiaAberta(true);
            // Force child (FormularioMateriaPrima) to load allocated materials for this garantia
            const garantiaId = garantia.id || garantia.Id;
            if (garantiaId && refFormularioMateriaPrima.current && typeof refFormularioMateriaPrima.current.carregarMateriasAlocadas === 'function') {
                try { await refFormularioMateriaPrima.current.carregarMateriasAlocadas(garantiaId); } catch (err) { console.warn('Aviso: falha ao carregar matérias-primas (garantia):', err); }
            }
            
            console.log('✅ Garantia encontrada:', garantia);
        } catch (error) {
            console.error('❌ Erro ao buscar garantia:', error);
            alert('Erro ao carregar dados da garantia para edição.');
        }
    };

    // Buscar responsáveis por garantia
    const fetchResponsaveisPorGarantia = async (garantiaId) => {
        try {
            const data = await apiCall(BASE_URLS_RESPONSAVEIS);
            const arr = Array.isArray(data) ? data : [];
            const responsaveisVinculados = arr.filter(r => (r.garantiaId || r.GarantiaId) == garantiaId);

            // Map to include pessoa name, custoHora and hours so UI can render reliably
            let pessoasArr = pessoas;
            try {
                const pessoasData = await apiCall(BASE_URLS_PESSOA);
                pessoasArr = Array.isArray(pessoasData) ? pessoasData : pessoasArr || [];
            } catch (errP) {
                pessoasArr = pessoasArr || [];
            }

            const mapped = [];
            for (const r of responsaveisVinculados) {
                const pessoasId = r.pessoasId || r.PessoasId || r.pessoasid || r.Pessoasid || r.PessoasId || null;
                const nestedPessoa = r.pessoa || r.Pessoa || r.Pessoas || r.PessoasObj || null;

                let pessoaObj = nestedPessoa || (pessoasArr.find(p => (p.id || p.Id) == pessoasId) || null);
                if (!pessoaObj && pessoasId) {
                    try {
                        const single = await apiCall(BASE_URLS_PESSOA, `${pessoasId}`);
                        pessoaObj = single || pessoaObj;
                    } catch (errSingle) {
                        // ignore
                    }
                }

                const nome = r.nome || r.Nome || (pessoaObj && (pessoaObj.nome || pessoaObj.Nome)) || (nestedPessoa && (nestedPessoa.nome || nestedPessoa.Nome)) || null;
                const custo = r.custoHora || r.CustoHora || (pessoaObj && (pessoaObj.custoHora || pessoaObj.CustoHora)) || null;
                const horasPrev = r.horasPrevistas || r.HorasPrevistas || r.horasPrev || r.HorasPrev || 0;
                const horasReal = r.horasReais || r.HorasReais || r.horasReal || r.HorasReal || 0;

                mapped.push({ ...r, nome, custoHora: custo, horasPrevistas: horasPrev, horasReais: horasReal });
            }

            setResponsaveisGarantia(mapped);
            return responsaveisVinculados;
        } catch (error) {
            console.error('❌ Erro ao buscar responsáveis da garantia:', error);
            setResponsaveisGarantia([]);
            return [];
        }
    };

    // Adicionar responsável à garantia
    const handleAdicionarResponsavel = async () => {
        if (!novoResponsavel.responsavelId) {
            alert('Selecione um responsável');
            return;
        }

        if (!dadosEdicao || !dadosEdicao.id) {
            alert('É necessário salvar a garantia antes de adicionar responsáveis');
            return;
        }

        try {
            // Preferimos criar o vínculo usando a tabela `Pessoas` (lista `pessoas`) selecionada na UI
            const pessoaSelecionada = pessoas.find(p => (p.id || p.Id) == novoResponsavel.responsavelId);

            if (!pessoaSelecionada) {
                alert('Pessoa selecionada não encontrada. Atualize a lista e tente novamente.');
                return;
            }

            // Montar payload compatível com o controller: PessoasId obrigatório, GarantiaId, ProducaoId, Id_cliente
            const payload = {
                id: 0,
                PessoasId: parseInt(pessoaSelecionada.id || pessoaSelecionada.Id),
                GarantiaId: parseInt(dadosEdicao.id),
                ProducaoId: dadosEdicao.producoesId ? parseInt(dadosEdicao.producoesId) : (dadosEdicao.ProducoesId ? parseInt(dadosEdicao.ProducoesId) : null),
                Id_cliente: dadosEdicao.id_cliente ? parseInt(dadosEdicao.id_cliente) : (dadosEdicao.Id_cliente ? parseInt(dadosEdicao.Id_cliente) : null),
                PerfilResponsavelId: pessoaSelecionada.perfilResponsavelId || pessoaSelecionada.PerfilResponsavelId || null,
                // Ao adicionar, só horas previstas; as reais são lançadas ao concluir a garantia
                HorasPrevistas: novoResponsavel.horasPrevistas ? parseFloat(novoResponsavel.horasPrevistas) : null
            };

            const created = await apiCall(BASE_URLS_RESPONSAVEIS, '', 'POST', payload);

            // Postar horas no endpoint canônico se houver valores
            const horasPrevistas = novoResponsavel.horasPrevistas ? parseFloat(novoResponsavel.horasPrevistas) : null;
            const horasReais = novoResponsavel.horasReais ? parseFloat(novoResponsavel.horasReais) : null;

            // Horas já foram incluídas no payload do Responsaveis (novo modelo)

            alert('Responsável adicionado com sucesso!');
            setAdicionarRespAberto(false);
            setNovoResponsavel({ responsavelId: '', horasPrevistas: '', horasReais: '' });

            // Recarregar responsáveis vinculados e lista geral
            await fetchResponsaveisPorGarantia(dadosEdicao.id);
            await fetchResponsaveis();
        } catch (error) {
            alert('Erro ao adicionar responsável: ' + error.message);
            console.error(error);
        }
    };

    // Marca/desmarca o responsável principal da garantia (só um; com um responsável só, ele é o principal)
    const handleDefinirPrincipal = async (responsavel) => {
        try {
            const id = responsavel.id || responsavel.responsaveisId || responsavel.ResponsaveisId;
            await apiCall(BASE_URLS_RESPONSAVEIS, `${id}/principal`, 'PUT', { principal: !ehPrincipal(responsavel) });
            if (dadosEdicao && dadosEdicao.id) await fetchResponsaveisPorGarantia(dadosEdicao.id);
            await fetchResponsaveis();
        } catch (error) {
            alert('Erro ao definir o responsável principal: ' + error.message);
        }
    };

    // Remover responsável da garantia
    const handleRemoverResponsavel = async (responsavel) => {
        if (!window.confirm(`Deseja remover ${responsavel.nome || responsavel.Nome}?`)) {
            return;
        }

        try {
            const id = responsavel.id || responsavel.responsaveisId || responsavel.ResponsaveisId;
            await apiCall(BASE_URLS_RESPONSAVEIS, `${id}`, 'DELETE');
            alert('Responsável removido com sucesso!');
            
            // Recarregar responsáveis
            if (dadosEdicao && dadosEdicao.id) {
                await fetchResponsaveisPorGarantia(dadosEdicao.id);
            }
            await fetchResponsaveis();
        } catch (error) {
            alert('Erro ao remover responsável: ' + error.message);
            console.error(error);
        }
    };

    // Filtrar produções com base no filtro e tipo
    useEffect(() => {
        if (!filtroProducao) {
            setProducoesFiltradas(producoes);
            return;
        }

        const val = filtroProducao.toLowerCase();
        const filtered = producoes.filter(p => {
            if (tipoFiltroProducao === 'todos') {
                const id = (p.producaoId || p.ProducaoId || '').toString().toLowerCase();
                const contratoId = (p.contratosId || p.ContratosId || '').toString().toLowerCase();
                const oportunidadeId = (p.oportunidadeId || p.OportunidadeId || '').toString().toLowerCase();
                const titulo = (p.oportunidadeTitulo || p.OportunidadeTitulo || '').toLowerCase();
                const clienteId = (p.clienteId || p.ClienteId || '').toString().toLowerCase();
                const vendaId = (p.vendaId || p.VendaId || '').toString().toLowerCase();
                return id.includes(val) || contratoId.includes(val) || oportunidadeId.includes(val) || 
                       titulo.includes(val) || clienteId.includes(val) || vendaId.includes(val);
            } else if (tipoFiltroProducao === 'producaoId') {
                return (p.producaoId || p.ProducaoId || '').toString().toLowerCase().includes(val);
            } else if (tipoFiltroProducao === 'contratoId') {
                return (p.contratosId || p.ContratosId || '').toString().toLowerCase().includes(val);
            } else if (tipoFiltroProducao === 'oportunidadeId') {
                return (p.oportunidadeId || p.OportunidadeId || '').toString().toLowerCase().includes(val);
            } else if (tipoFiltroProducao === 'titulo') {
                return (p.oportunidadeTitulo || p.OportunidadeTitulo || '').toLowerCase().includes(val);
            } else if (tipoFiltroProducao === 'clienteId') {
                return (p.clienteId || p.ClienteId || '').toString().toLowerCase().includes(val);
            } else if (tipoFiltroProducao === 'vendaId') {
                return (p.vendaId || p.VendaId || '').toString().toLowerCase().includes(val);
            }
            return true;
        });
        setProducoesFiltradas(filtered);
    }, [filtroProducao, tipoFiltroProducao, producoes]);

    // Função para selecionar produção e abrir formulário
    const selecionarProducao = (producao) => {
        setProducaoSelecionada(producao);
        setSelecionarProducaoAberto(false);
        setNovaGarantiaAberta(true);
    };

    // Filtrar garantias
    const garantiasFiltradas = garantias.filter(garantia => {
        if (!filtro) return true;

        const valorFiltro = filtro.toLowerCase();

        switch (tipoFiltro) {
            case 'idGarantia':
                return String(garantia.id || garantia.Id).toLowerCase().includes(valorFiltro);
            case 'idProducao':
                return String(garantia.producoesId || garantia.ProducoesId || '').toLowerCase().includes(valorFiltro);
            case 'idCliente':
                return String(garantia.id_cliente || garantia.Id_cliente || '').toLowerCase().includes(valorFiltro);
            case 'idContrato':
                return String(garantia.contratoId || garantia.ContratoId || '').toLowerCase().includes(valorFiltro);
            case 'status':
                return (garantia.status || garantia.Status || '').toLowerCase().includes(valorFiltro);
            case 'data':
                return (garantia.dataSolicitacao || garantia.DataSolicitacao || '').toLowerCase().includes(valorFiltro);
            default:
                return true;
        }
    });

    // Obter nome da produção
    const getNomeProducao = (producaoId) => {
        const producao = producoes.find(p => (p.producaoId || p.ProducaoId) === producaoId);
        return producao ? (producao.titulo || producao.Titulo || `Projeto #${producaoId}`) : `ID: ${producaoId}`;
    };

    // Obter nome do cliente
    const getNomeCliente = (clienteId) => {
        const cliente = clientes.find(c => (c.id || c.Id) === clienteId);
        return cliente ? (cliente.nome || cliente.Nome) : `ID: ${clienteId}`;
    };

    // Obter número do contrato
    const getNumeroContrato = (contratoId) => {
        const contrato = contratos.find(c => (c.id || c.Id) === contratoId);
        return contrato ? (contrato.numeroContrato || contrato.NumeroContrato || `Contrato #${contratoId}`) : `ID: ${contratoId}`;
    };

    // Função para obter cor do status
    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'solicitada':
                return 'rgb(235, 133, 0)'; // Laranja
            case 'em análise':
                return '#2196f3'; // Azul
            case 'aprovada':
                return '#4caf50'; // Verde
            case 'em andamento':
                return '#9c27b0'; // Roxo
            case 'concluída':
                return '#4caf50'; // Verde escuro
            case 'recusada':
                return '#f44336'; // Vermelho
            case 'cancelada':
                return '#757575'; // Cinza
            default:
                return '#666';
        }
    };

    // Formulário para criar/editar garantia
    const handleSubmitGarantia = async (dadosFormulario) => {
        // Diminuição de matéria-prima sem dizer o destino do material (perdido / volta ao estoque): não salva
        if (refFormularioMateriaPrima.current?.validarAlteracoes && !refFormularioMateriaPrima.current.validarAlteracoes()) return;
        try {
            setLoading(true);
            console.log('handleSubmitGarantia received:', dadosFormulario, 'responsaveis length:', dadosFormulario?.responsaveis?.length || 0);
            
            if (modoEdicao && dadosEdicao) {
                // Editar garantia existente (sem responsáveis no form de edição)
                const garantiaId = dadosEdicao.id || dadosEdicao.Id;
                // Concluindo a garantia: as horas reais de cada responsável são informadas agora (no pop-up)
                const concluindo = /conclu/i.test(dadosFormulario.status || '') && !/conclu/i.test(dadosEdicao.status || dadosEdicao.Status || '');
                if (concluindo && responsaveisGarantia.length > 0 && horasReaisConclusaoRef.current === null) {
                    setConclusaoPendente(dadosFormulario);
                    return;
                }
                if (concluindo && horasReaisConclusaoRef.current) {
                    await salvarHorasReais(horasReaisConclusaoRef.current);
                    horasReaisConclusaoRef.current = null;
                }
                const garantiaData = {
                    Id: parseInt(garantiaId),
                    ContratoId: dadosFormulario.contratoId ? parseInt(dadosFormulario.contratoId) : null,
                    Id_cliente: dadosFormulario.id_cliente ? parseInt(dadosFormulario.id_cliente) : null,
                    ProducoesId: dadosFormulario.producoesId ? parseInt(dadosFormulario.producoesId) : null,
                    DataSolicitacao: dadosFormulario.dataSolicitacao || null,
                    Status: dadosFormulario.status || 'Solicitada',
                    DescricaoProblema: dadosFormulario.descricaoProblema || '',
                    CustoGarantia: dadosFormulario.custoGarantia ? parseFloat(dadosFormulario.custoGarantia) : null,
                    PessoaId: dadosFormulario.pessoaId ? parseInt(dadosFormulario.pessoaId) : null
                };
                
                console.log('Editando garantia:', garantiaId, garantiaData);
                await apiCall(BASE_URLS, `${garantiaId}`, 'PUT', garantiaData);
                
                // POST de matérias-primas alocadas (modo edição também aloca)
                if (refFormularioMateriaPrima.current) {
                    try {
                        const resultAloc = await refFormularioMateriaPrima.current.alocarMateriaisParaTarefa(garantiaId);
                        console.log('✅ Matérias-primas alocadas para garantia (edição):', resultAloc);
                    } catch (errMat) {
                        console.warn('Aviso: Erro ao alocar matérias-primas (garantia foi editada):', errMat);
                        // Não bloqueia a edição se matérias-primas falharem
                    }
                }
                
                alert('Garantia editada com sucesso!');
            } else {
                // Criar nova garantia
                const garantiaData = {
                    contratoId: dadosFormulario.contratoId,
                    id_cliente: dadosFormulario.id_cliente,
                    producoesId: dadosFormulario.producoesId,
                    dataSolicitacao: dadosFormulario.dataSolicitacao || null,
                    status: dadosFormulario.status || 'Pendente',
                    descricaoProblema: dadosFormulario.descricaoProblema || '',
                    custoGarantia: dadosFormulario.custoGarantia,
                    pessoaId: dadosFormulario.pessoaId
                };
                
                console.log('Criando garantia:', garantiaData);
                const criada = await apiCall(BASE_URLS, '', 'POST', garantiaData);
                console.log('Resposta do POST /api/Garantia:', criada);
                const garantiaId = criada?.id || criada?.Id;
                // POST de responsáveis vinculados à garantia (igual Tarefas)
                console.log('Preparando para criar responsáveis:', { garantiaId, responsaveis: dadosFormulario.responsaveis, responsaveisDados: dadosFormulario.responsaveisDados });
                if (garantiaId && dadosFormulario.responsaveis && dadosFormulario.responsaveis.length > 0) {
                    for (let i = 0; i < dadosFormulario.responsaveis.length; i++) {
                        const pessoaId = dadosFormulario.responsaveis[i];
                        if (pessoaId) {
                            try {
                                // Busca os dados completos da pessoa a partir do estado `pessoas`
                                const pessoaSelecionada = pessoas.find(p => (p.id || p.Id) == pessoaId);
                                const dadosCompletos = dadosFormulario.responsaveisDados[i] || {};

                                const payloadResponsavel = {
                                    id: 0,
                                    PessoasId: parseInt(pessoaId),
                                    GarantiaId: parseInt(garantiaId),
                                    ProducaoId: dadosFormulario.producoesId ? parseInt(dadosFormulario.producoesId) : null,
                                    id_cliente: dadosFormulario.id_cliente ? parseInt(dadosFormulario.id_cliente) : null,
                                    // Horas da linha (antes não eram enviadas) e o principal escolhido
                                    HorasPrevistas: dadosCompletos.horasPrevistas || null,
                                    HorasReais: dadosCompletos.horasReais || null,
                                    ResponsavelPrincipal: !!dadosCompletos.principal
                                };

                                                console.log('Criando responsável vinculado à garantia (PessoasId):', payloadResponsavel, 'pessoa:', pessoaSelecionada);
                                                const createdResp = await apiCall(BASE_URLS_RESPONSAVEIS, '', 'POST', payloadResponsavel);
                                                console.log('Responsável criado com horas incluídas:', createdResp);
                            } catch (errResp) {
                                console.error('Erro ao vincular responsável:', errResp);
                                // Continua mesmo se falhar para um responsável
                            }
                        }
                    }
                }

                // 3. POST de matérias-primas alocadas para a garantia
                if (refFormularioMateriaPrima.current) {
                    try {
                        const resultAloc = await refFormularioMateriaPrima.current.alocarMateriaisParaTarefa(garantiaId);
                        console.log('✅ Matérias-primas alocadas para garantia:', resultAloc);
                    } catch (errMat) {
                        console.error('Aviso: Erro ao alocar matérias-primas (garantia foi criada):', errMat);
                        // Não bloqueia a criação da garantia se matérias-primas falharem
                    }
                }

                alert(`Garantia criada com sucesso!${dadosFormulario.responsaveis?.length ? `\n\n${dadosFormulario.responsaveis.length} responsável(is) vinculado(s).` : ''}`);
            }

            // Resetar formulário e recarregar lista
            setNovaGarantiaAberta(false);
            setModoEdicao(false);
            setDadosEdicao(null);
            setProducaoSelecionada(null);
            await fetchGarantias();
            await fetchResponsaveis();
            
        } catch (error) {
            console.error('Erro ao salvar garantia:', error);
            alert('Erro ao salvar garantia: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    // Funções do Calendário
    const abrirCalendario = () => {
        processarGarantiasPorData();
        setCalendarioAberto(true);
    };

    const processarGarantiasPorData = () => {
        const garantiasPorDataMap = {};
        
        garantias.forEach(garantia => {
            const dataSolicitacao = garantia.DataSolicitacao || garantia.dataSolicitacao;
            if (!dataSolicitacao) return;

            const data = dataSolicitacao.split('T')[0]; // YYYY-MM-DD
            
            if (!garantiasPorDataMap[data]) {
                garantiasPorDataMap[data] = [];
            }
            
            garantiasPorDataMap[data].push(garantia);
        });
        
        setGarantiasPorData(garantiasPorDataMap);
    };

    const selecionarDia = (data) => {
        const dataStr = `${data.getFullYear()}-${(data.getMonth() + 1).toString().padStart(2, '0')}-${data.getDate().toString().padStart(2, '0')}`;
        const garantias = garantiasPorData[dataStr];
        
        if (garantias && garantias.length > 0) {
            setGarantiasDoDia(garantias);
            setDatasSelecionadas(data);
            setMostrarGarantiasDoDia(true);
        }
    };

    const editarGarantiaDoDia = async (garantia) => {
        const garantiaId = garantia.Id || garantia.id;
        await fetchGarantiaPorId(garantiaId);
        setModoEdicao(true);
        setMostrarGarantiasDoDia(false);
        setCalendarioAberto(false);
        setNovaGarantiaAberta(true);
    };

    const renderCalendario = () => {
        const ano = mesAtual.getFullYear();
        const mes = mesAtual.getMonth();
        
        // Nomes dos meses
        const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 
                       'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
        
        // Nomes dos dias da semana
        const diasSemana = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB'];
        
        // Primeiro dia do mês e total de dias
        const primeiroDia = new Date(ano, mes, 1);
        const diasNoMes = new Date(ano, mes + 1, 0).getDate();
        const primeiroDiaSemana = primeiroDia.getDay();
        
        // Dias do mês anterior
        const diasMesAnterior = new Date(ano, mes, 0).getDate();
        
        // Construir array de dias
        const dias = [];
        
        // Dias do mês anterior
        for (let i = primeiroDiaSemana - 1; i >= 0; i--) {
            dias.push({
                dia: diasMesAnterior - i,
                foraDoMes: true,
                data: new Date(ano, mes - 1, diasMesAnterior - i)
            });
        }
        
        // Dias do mês atual
        for (let i = 1; i <= diasNoMes; i++) {
            dias.push({
                dia: i,
                foraDoMes: false,
                data: new Date(ano, mes, i)
            });
        }
        
        // Dias do próximo mês (completar 42 dias = 6 semanas)
        const totalDiasCalendario = 42;
        const diasRestantes = totalDiasCalendario - dias.length;
        
        for (let i = 1; i <= diasRestantes; i++) {
            dias.push({
                dia: i,
                foraDoMes: true,
                data: new Date(ano, mes + 1, i)
            });
        }
        
        return (
            <div>
                {/* Cabeçalho com navegação */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '12px',
                    position: 'relative'
                }}>
                    <button 
                        onClick={() => setMesAtual(new Date(ano, mes - 1, 1))}
                        style={{
                            border: 'none',
                            background: 'none',
                            fontSize: '20px',
                            cursor: 'pointer',
                            color: '#444',
                            padding: '0 12px',
                            borderRadius: '4px',
                            margin: '0 5px'
                        }}
                    >
                        &#8592;
                    </button>
                    
                    <select
                        value={mes}
                        onChange={(e) => setMesAtual(new Date(ano, parseInt(e.target.value), 1))}
                        style={{
                            fontWeight: 'bold',
                            fontSize: '16px',
                            padding: '4px 8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            backgroundColor: 'white',
                            marginRight: '10px'
                        }}
                    >
                        {meses.map((nomeMes, idx) => (
                            <option key={idx} value={idx}>
                                {nomeMes}
                            </option>
                        ))}
                    </select>
                    
                    <select
                        value={ano}
                        onChange={(e) => setMesAtual(new Date(parseInt(e.target.value), mes, 1))}
                        style={{
                            fontWeight: 'bold',
                            fontSize: '16px',
                            padding: '4px 8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            backgroundColor: 'white'
                        }}
                    >
                        {Array.from({ length: 31 }, (_, i) => 2020 + i).map(anoOpcao => (
                            <option key={anoOpcao} value={anoOpcao}>
                                {anoOpcao}
                            </option>
                        ))}
                    </select>
                    
                    <button 
                        onClick={() => setMesAtual(new Date(ano, mes + 1, 1))}
                        style={{
                            border: 'none',
                            background: 'none',
                            fontSize: '20px',
                            cursor: 'pointer',
                            color: '#444',
                            padding: '0 12px',
                            borderRadius: '4px',
                            margin: '0 5px'
                        }}
                    >
                        &#8594;
                    </button>
                </div>
                
                {/* Dias da semana */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gap: '4px',
                    marginBottom: '8px'
                }}>
                    {diasSemana.map(dia => (
                        <div
                            key={dia}
                            style={{
                                textAlign: 'center',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                padding: '6px 0',
                                color: '#444'
                            }}
                        >
                            {dia}
                        </div>
                    ))}
                </div>
                
                {/* Grid de dias */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gridTemplateRows: 'repeat(6, 1fr)',
                    gap: '4px'
                }}>
                    {dias.map((dia, index) => {
                        // Obter garantias deste dia
                        const dataStr = `${dia.data.getFullYear()}-${(dia.data.getMonth() + 1).toString().padStart(2, '0')}-${dia.data.getDate().toString().padStart(2, '0')}`;
                        const garantiasDoDiaAtual = garantiasPorData[dataStr] || [];
                        const qtdGarantias = garantiasDoDiaAtual.length;
                        
                        // Verificar status
                        const now = new Date();
                        const nowSemHoras = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                        const diaSemHoras = new Date(dia.data.getFullYear(), dia.data.getMonth(), dia.data.getDate());
                        
                        let temAtrasado = false;
                        let temVencendo = false;
                        
                        if (diaSemHoras < nowSemHoras && !dia.foraDoMes && qtdGarantias > 0) {
                            temAtrasado = true;
                        } else if (diaSemHoras >= nowSemHoras) {
                            const diffDays = Math.floor((diaSemHoras - nowSemHoras) / (1000 * 60 * 60 * 24));
                            if (diffDays <= 3 && qtdGarantias > 0) {
                                temVencendo = true;
                            }
                        }
                        
                        return (
                            <div
                                key={`${dia.dia}-${index}`}
                                style={{
                                    height: '84px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    position: 'relative',
                                    backgroundColor: dia.foraDoMes ? '#f5f5f5' : '#fff',
                                    transition: 'all 0.2s ease',
                                    overflow: 'hidden',
                                    cursor: dia.foraDoMes ? 'default' : 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    if (!dia.foraDoMes) {
                                        e.currentTarget.querySelector('.overlay-calendario-garantia')?.classList.add('visible');
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.querySelector('.overlay-calendario-garantia')?.classList.remove('visible');
                                }}
                            >
                                <span style={{
                                    position: 'absolute',
                                    top: '4px',
                                    left: '6px',
                                    fontSize: '14px',
                                    fontWeight: 'normal',
                                    color: dia.foraDoMes ? '#aaa' : '#111'
                                }}>
                                    {dia.dia}
                                </span>
                                
                                {qtdGarantias > 0 && !dia.foraDoMes && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '25px',
                                        left: '6px',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        color: temAtrasado ? '#ff0000' : temVencendo ? '#ffaa00' : '#333',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        maxWidth: '90%'
                                    }}>
                                        <div style={{ marginBottom: '2px' }}>
                                            🛡️ {qtdGarantias} {qtdGarantias === 1 ? 'garantia' : 'garantias'}
                                        </div>
                                        
                                        {/* Resumo das primeiras 2 garantias */}
                                        {garantiasDoDiaAtual.slice(0, 2).map((garantia, idx) => {
                                            const clienteId = garantia.Id_cliente || garantia.id_cliente;
                                            return (
                                                <div key={idx} style={{
                                                    fontSize: '10px',
                                                    color: '#666',
                                                    marginBottom: '1px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    maxWidth: '100%'
                                                }}>
                                                    Cliente #{clienteId}
                                                </div>
                                            );
                                        })}
                                        
                                        {qtdGarantias > 2 && (
                                            <div style={{ fontSize: '10px', color: '#999', fontStyle: 'italic' }}>
                                                e mais {qtdGarantias - 2}...
                                            </div>
                                        )}
                                        
                                        {temAtrasado && (
                                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '2px' }}>
                                                <span style={{ 
                                                    width: '8px', 
                                                    height: '8px', 
                                                    borderRadius: '50%', 
                                                    backgroundColor: '#ff0000',
                                                    marginRight: '4px'
                                                }} />
                                                <span style={{ fontSize: '11px', color: '#ff0000', fontWeight: 'bold' }}>Atrasado</span>
                                            </div>
                                        )}
                                        
                                        {!temAtrasado && temVencendo && (
                                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '2px' }}>
                                                <span style={{ 
                                                    width: '8px', 
                                                    height: '8px', 
                                                    borderRadius: '50%', 
                                                    backgroundColor: '#ffaa00',
                                                    marginRight: '4px'
                                                }} />
                                                <span style={{ fontSize: '11px', color: '#ffaa00', fontWeight: 'bold' }}>Vencendo</span>
                                            </div>
                                        )}
                                    </div>
                                )}
                                
                                {!dia.foraDoMes && (
                                    <div className="overlay-calendario-garantia" style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 1,
                                        opacity: 0,
                                        pointerEvents: 'none',
                                        transition: 'opacity 0.2s ease'
                                    }}>
                                        <button 
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                selecionarDia(dia.data);
                                            }}
                                            style={{
                                                backgroundColor: 'rgb(235, 133, 0)',
                                                border: 'none',
                                                borderRadius: qtdGarantias > 0 ? '5px' : '50%',
                                                color: 'white',
                                                padding: qtdGarantias > 0 ? '6px 12px' : '0',
                                                width: qtdGarantias > 0 ? 'auto' : '36px',
                                                height: qtdGarantias > 0 ? 'auto' : '36px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: qtdGarantias > 0 ? '12px' : '20px',
                                                fontWeight: 'bold',
                                                cursor: 'pointer',
                                                zIndex: 2,
                                                boxShadow: 'none',
                                                pointerEvents: 'auto'
                                            }}>
                                            {qtdGarantias > 0 ? 'Ver todas' : '+'}
                                        </button>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <div className="container-geral fundo-branco">
            <MobileAddListener onOpen={() => { setModoEdicao(false); setDadosEdicao(null); setSelecionarProducaoAberto(true); }} />
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h2 style={{ margin: '0 0 15px 0', color: 'rgb(235, 133, 0)' }}>🛡️ Garantia</h2>
                <button 
                    onClick={() => {
                        setModoEdicao(false);
                        setDadosEdicao(null);
                        setSelecionarProducaoAberto(true);
                    }}
                    className="btn-adicionar"
                    style={{
                        backgroundColor: 'rgb(235, 133, 0)',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: 600
                    }}
                >
                    Adicionar Garantia
                </button>
            </div>

            {/* Campo de filtro */}
            <div className="filtro-container">
                <label className="filtro-label">Filtrar por:</label>
                <div className="filtro-input-container">
                    <div className="filtro-input-wrapper">
                        <input
                            type="text"
                            className="filtro-input"
                            placeholder={`Filtrar por ${
                                opcoesFiltro.find(op => op.value === tipoFiltro)?.label || tipoFiltro
                            }`}
                            value={filtro}
                            onChange={e => setFiltro(e.target.value)}
                        />
                        {filtro && (
                            <button
                                className="filtro-clear-button"
                                onClick={() => setFiltro('')}
                                title="Limpar filtro"
                            >
                                ×
                            </button>
                        )}
                    </div>

                    <div className="filtro-custom-select">
                        <button
                            className="filtro-custom-botao"
                            onClick={() => setDropdownAberto(!dropdownAberto)}
                        >
                            {opcoesFiltro.find(op => op.value === tipoFiltro)?.label || tipoFiltro}
                            <span className="seta-para-baixo">▼</span>
                        </button>
                        {dropdownAberto && (
                            <div className="filtro-custom-opcoes">
                                {opcoesFiltro.map(op => (
                                    <div
                                        key={op.value}
                                        onClick={() => {
                                            setTipoFiltro(op.value);
                                            setDropdownAberto(false);
                                        }}
                                    >
                                        {op.label}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Botão do Calendário */}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px' }}>
                <button
                    onClick={abrirCalendario}
                    style={{
                        fontSize: '36px',
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '10px',
                        transition: 'transform 0.2s',
                        filter: 'none'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                    }}
                    title="Ver calendário de garantias"
                >
                    📅
                </button>
            </div>

            {/* Lista de Garantias */}
            {loading ? (
                <div className="loading">⏳ Carregando garantias...</div>
            ) : (
                <div className="lista-entregas">
                    <div className="entregas-header">
                        <span>Total de garantias: {garantiasFiltradas.length}</span>
                    </div>
                    {garantiasFiltradas.length === 0 ? (
                        <div className="sem-entregas">
                            <p>🛡️ Nenhuma garantia encontrada</p>
                            <p>Clique em "+" para registrar a primeira solicitação de garantia</p>
                        </div>
                    ) : (
                        <div className="garantia-cards-container">
                            {garantiasFiltradas.map(garantia => {
                                const garantiaId = garantia.id || garantia.Id;
                                const status = garantia.status || garantia.Status || 'Solicitada';
                                const statusColor = getStatusColor(status);

                                return (
                                    <div 
                                        key={garantiaId} 
                                        className="garantia-card"
                                    >
                                        <div className="garantia-card-content">
                                            <div className="garantia-card-header">
                                                Garantia #{garantiaId}
                                                <span className="garantia-status-badge" style={{ backgroundColor: statusColor }}>
                                                    {status}
                                                </span>
                                            </div>
                                            
                                            <div className="garantia-card-fields">
                                                {/* Contrato */}
                                                {(garantia.contratoId || garantia.ContratoId) && (
                                                    <div className="garantia-field">
                                                        <span className="garantia-field-label">Contrato:</span>{' '}
                                                        <span className="garantia-field-value garantia-field-link">
                                                            {getNumeroContrato(garantia.contratoId || garantia.ContratoId)}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Projeto */}
                                                {(garantia.producoesId || garantia.ProducoesId) && (
                                                    <div className="garantia-field">
                                                        <span className="garantia-field-label">Projeto:</span>{' '}
                                                        <span className="garantia-field-value garantia-field-link">
                                                            {getNomeProducao(garantia.producoesId || garantia.ProducoesId)}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Cliente */}
                                                {(garantia.id_cliente || garantia.Id_cliente) && (
                                                    <div className="garantia-field">
                                                        <span className="garantia-field-label">Cliente:</span>{' '}
                                                        <span className="garantia-field-value garantia-field-success">
                                                            {getNomeCliente(garantia.id_cliente || garantia.Id_cliente)}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Data Solicitação */}
                                                {(garantia.dataSolicitacao || garantia.DataSolicitacao) && (
                                                    <div className="garantia-field">
                                                        <span className="garantia-field-label">Data:</span>{' '}
                                                        <span className="garantia-field-value">
                                                            {new Date(garantia.dataSolicitacao || garantia.DataSolicitacao).toLocaleDateString('pt-BR')}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Custo */}
                                                {(garantia.custoGarantia || garantia.CustoGarantia) !== null && (
                                                    <div className="garantia-field">
                                                        <span className="garantia-field-label">Custo:</span>{' '}
                                                        <span className="garantia-field-value garantia-field-price">
                                                            R$ {parseFloat(garantia.custoGarantia || garantia.CustoGarantia || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Descrição do Problema */}
                                                {(garantia.descricaoProblema || garantia.DescricaoProblema) && (
                                                    <div className="garantia-field garantia-field-full">
                                                        <span className="garantia-field-label">Problema:</span>{' '}
                                                        <span className="garantia-field-value">
                                                            {garantia.descricaoProblema || garantia.DescricaoProblema}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Responsável: o principal; sem principal e com vários, "N responsáveis" */}
                                            {(responsaveisPorGarantia[garantiaId]?.length > 0 || garantia.pessoa) && (
                                                <div className="garantia-pessoa-info">
                                                    <span style={{ fontWeight: '600', color: '#666' }}>👤 Responsável:</span>{' '}
                                                    {responsaveisPorGarantia[garantiaId]?.length > 0
                                                        ? textoResponsavelCard(responsaveisPorGarantia[garantiaId], r => r.pessoaNome ?? r.PessoaNome)
                                                        : (garantia.pessoa.nomePessoa || garantia.pessoa.NomePessoa)}
                                                </div>
                                            )}
                                        </div>

                                        <div className="garantia-card-actions">
                                            <button 
                                                className="btn-editar-garantia"
                                                onClick={() => fetchGarantiaPorId(garantiaId)}
                                            >
                                                Editar
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            )}

            {/* Modal de Nova/Editar Garantia */}
            {novaGarantiaAberta && (
                <div className="modal-overlay" style={{ zIndex: 95000 }} onClick={() => {
                    setNovaGarantiaAberta(false);
                    setModoEdicao(false);
                    setDadosEdicao(null);
                }}>
                    <div 
                        className="modal-content" 
                        onClick={e => e.stopPropagation()} 
                        style={{ 
                            maxWidth: 900, 
                            minWidth: 600, 
                            width: '90vw', 
                            padding: 32, 
                            borderRadius: 16,
                            maxHeight: '90vh',
                            overflowY: 'auto'
                        }}
                    >
                        <div className="modal-header">
                            <h3>{modoEdicao ? 'Editar Garantia' : 'Nova Garantia'}</h3>
                            <button 
                                className="modal-close"
                                onClick={() => {
                                    setNovaGarantiaAberta(false);
                                    setModoEdicao(false);
                                    setDadosEdicao(null);
                                    setProducaoSelecionada(null);
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {/* Exibir projeto selecionado */}
                        {producaoSelecionada && !modoEdicao && (
                            <div style={{
                                padding: '12px 16px',
                                backgroundColor: '#fff3e0',
                                borderRadius: '6px',
                                marginBottom: '20px',
                                border: '1px solid rgb(235, 133, 0)'
                            }}>
                                <div style={{ fontSize: '13px', fontWeight: 600, color: 'rgb(235, 133, 0)', marginBottom: '4px' }}>
                                    Projeto Selecionado
                                </div>
                                <div style={{ fontSize: '12px', color: '#666' }}>
                                    ID Projeto: {producaoSelecionada.producaoId || producaoSelecionada.ProducaoId} | Cliente: {producaoSelecionada.clienteId || producaoSelecionada.ClienteId}
                                </div>
                            </div>
                        )}

                        <FormularioGarantia
                            onSubmit={handleSubmitGarantia}
                            onCancel={() => {
                                setNovaGarantiaAberta(false);
                                setModoEdicao(false);
                                setDadosEdicao(null);
                                setProducaoSelecionada(null);
                            }}
                            responsaveis={pessoas}
                            producaoSelecionada={producaoSelecionada}
                            modoEdicao={modoEdicao}
                            dadosEdicao={dadosEdicao}
                            onCriarResponsavel={() => setNovoPessoaAberto(true)}
                            responsaveisGarantia={responsaveisGarantia}
                            onAdicionarResponsavel={() => setAdicionarRespAberto(true)}
                            onRemoverResponsavel={handleRemoverResponsavel}
                            onDefinirPrincipal={handleDefinirPrincipal}
                            refFormularioMateriaPrima={refFormularioMateriaPrima}
                        />
                    </div>
                </div>
            )}

            {/* Modal do Calendário */}
            {calendarioAberto && (
                <>
                    <style>{`
                        .overlay-calendario-garantia.visible {
                            opacity: 1 !important;
                            pointer-events: auto !important;
                        }
                    `}</style>
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 95000
                    }}>
                        <div style={{
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            padding: '20px',
                            maxWidth: '900px',
                            width: '90%',
                            maxHeight: '85vh',
                            overflow: 'auto',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                            position: 'relative'
                        }}>
                            <button
                                onClick={() => setCalendarioAberto(false)}
                                style={{
                                    position: 'absolute',
                                    top: '15px',
                                    right: '15px',
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '28px',
                                    cursor: 'pointer',
                                    color: '#666',
                                    fontWeight: 700,
                                    width: '35px',
                                    height: '35px',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s',
                                    padding: 0
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#f0f0f0';
                                    e.currentTarget.style.color = 'rgb(235, 133, 0)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                    e.currentTarget.style.color = '#666';
                                }}
                            >
                                ×
                            </button>

                            <h2 style={{ marginTop: 0, marginBottom: '20px', color: 'rgb(235, 133, 0)', textAlign: 'center', fontSize: '20px' }}>
                                🛡️ Calendário de Garantias
                            </h2>

                            {renderCalendario()}

                            <div style={{ marginTop: '15px', padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
                                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center', fontSize: '12px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#f44336' }}></div>
                                        <span>Atrasado</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#ffa726' }}></div>
                                        <span>Vencendo (até 3 dias)</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {/* Modal de Garantias do Dia */}
            {mostrarGarantiasDoDia && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 95010
                }} onClick={() => setMostrarGarantiasDoDia(false)}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        padding: '20px',
                        maxWidth: '950px',
                        width: '90%',
                        maxHeight: '80vh',
                        overflow: 'auto',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                        position: 'relative'
                    }} onClick={(e) => e.stopPropagation()}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px',
                            padding: '10px 0',
                            borderBottom: '1px solid #eee'
                        }}>
                            <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: '0', color: 'rgb(235, 133, 0)' }}>
                                🛡️ Garantias - {datasSelecionadas && datasSelecionadas.toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' })}
                            </h2>
                            
                            <button 
                                onClick={() => setMostrarGarantiasDoDia(false)}
                                style={{
                                    border: 'none',
                                    background: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    color: '#444',
                                    padding: '0 15px'
                                }}
                            >
                                ×
                            </button>
                        </div>

                        <div className="lista-clientes">
                            {garantiasDoDia.length === 0 && (
                                <div style={{
                                    textAlign: 'center',
                                    padding: '30px',
                                    color: '#888'
                                }}>
                                    Nenhuma garantia para esta data.
                                </div>
                            )}
                            
                            {garantiasDoDia.map(garantia => {
                                const garantiaId = garantia.Id || garantia.id;
                                const clienteId = garantia.Id_cliente || garantia.id_cliente;
                                const dataSolicitacao = garantia.DataSolicitacao || garantia.dataSolicitacao;
                                const status = garantia.Status || garantia.status || 'Solicitada';
                                const descricaoProblema = garantia.DescricaoProblema || garantia.descricaoProblema || '';
                                
                                let hora = 'N/D';
                                if (dataSolicitacao) {
                                    const partesDataHora = dataSolicitacao.replace('T', ' ').split(' ');
                                    if (partesDataHora.length > 1) {
                                        hora = partesDataHora[1].substring(0, 5);
                                    }
                                }

                                return (
                                    <div 
                                        key={garantiaId}
                                        style={{ 
                                            display: 'flex', 
                                            borderBottom: '1px solid #ddd', 
                                            padding: '10px 0',
                                            cursor: 'pointer',
                                            transition: 'background-color 0.2s'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#f9f9f9';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        <div style={{ 
                                            width: '80%', 
                                            display: 'flex', 
                                            flexDirection: 'row', 
                                            gap: '20px', 
                                            padding: '10px 0' 
                                        }}>
                                            {/* Coluna ID */}
                                            <div style={{ display: 'flex', flexDirection: 'column', minWidth: '60px' }}>
                                                <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>ID</label>
                                                <span>{garantiaId}</span>
                                            </div>
                                            
                                            {/* Coluna ID Cliente */}
                                            <div style={{ display: 'flex', flexDirection: 'column', minWidth: '80px' }}>
                                                <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>ID Cliente</label>
                                                <span>{clienteId || 'N/A'}</span>
                                            </div>
                                            
                                            {/* Coluna Hora */}
                                            <div style={{ display: 'flex', flexDirection: 'column', minWidth: '80px' }}>
                                                <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Hora</label>
                                                <span>{hora}</span>
                                            </div>
                                            
                                            {/* Coluna Status */}
                                            <div style={{ display: 'flex', flexDirection: 'column', minWidth: '120px' }}>
                                                <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Status</label>
                                                <span style={{ 
                                                    fontSize: '12px', 
                                                    padding: '2px 8px', 
                                                    borderRadius: '10px', 
                                                    backgroundColor: getStatusColor(status),
                                                    color: 'white',
                                                    fontWeight: 600,
                                                    display: 'inline-block',
                                                    width: 'fit-content'
                                                }}>
                                                    {status}
                                                </span>
                                            </div>
                                            
                                            {/* Coluna Descrição */}
                                            {descricaoProblema && (
                                                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                                    <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Descrição</label>
                                                    <span style={{ 
                                                        overflow: 'hidden', 
                                                        textOverflow: 'ellipsis', 
                                                        whiteSpace: 'nowrap' 
                                                    }}>
                                                        {descricaoProblema.length > 30 ? `${descricaoProblema.substring(0, 30)}...` : descricaoProblema}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        
                                        <div style={{ 
                                            width: '20%', 
                                            display: 'flex', 
                                            justifyContent: 'flex-end', 
                                            alignItems: 'center' 
                                        }}>
                                            <button
                                                onClick={() => editarGarantiaDoDia(garantia)}
                                                style={{
                                                    backgroundColor: 'rgb(235, 133, 0)',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    padding: '8px 15px',
                                                    cursor: 'pointer',
                                                    fontWeight: 'bold',
                                                    fontSize: '14px',
                                                    transition: 'background-color 0.2s'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'rgb(208, 116, 0)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'rgb(235, 133, 0)';
                                                }}
                                            >
                                                Editar
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Seleção de Projeto */}
            {selecionarProducaoAberto && (
                <div className="modal-overlay" onClick={() => setSelecionarProducaoAberto(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 95020 }}>
                    <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: '95%', maxWidth: 1000, background: '#fff', borderRadius: 12, padding: 20, maxHeight: '90vh', overflowY: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                            <h3 style={{ margin: 0, color: 'rgb(235, 133, 0)' }}>Selecione um Projeto</h3>
                            <button onClick={() => setSelecionarProducaoAberto(false)} aria-label="Fechar" style={{ backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: '50%', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, cursor: 'pointer' }}>×</button>
                        </div>

                        {/* Filtro de Projeto */}
                        <div style={{ marginBottom: 16, display: 'flex', gap: 10, alignItems: 'center' }}>
                            <input
                                type="text"
                                placeholder={`Filtrar por ${
                                    tipoFiltroProducao === 'todos' ? 'todos os campos' :
                                    tipoFiltroProducao === 'producaoId' ? 'ID Projeto' :
                                    tipoFiltroProducao === 'contratoId' ? 'Contrato ID' :
                                    tipoFiltroProducao === 'oportunidadeId' ? 'Oportunidade ID' :
                                    tipoFiltroProducao === 'titulo' ? 'Título' :
                                    tipoFiltroProducao === 'clienteId' ? 'Cliente ID' :
                                    tipoFiltroProducao === 'vendaId' ? 'Venda ID' : ''
                                }...`}
                                value={filtroProducao}
                                onChange={(e) => setFiltroProducao(e.target.value)}
                                style={{ flex: 1, padding: '10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 14 }}
                            />
                            <select
                                value={tipoFiltroProducao}
                                onChange={(e) => setTipoFiltroProducao(e.target.value)}
                                style={{ 
                                    padding: '10px 16px', 
                                    borderRadius: 6, 
                                    border: '1px solid #ddd', 
                                    fontSize: 14, 
                                    backgroundColor: 'rgb(235, 133, 0)', 
                                    color: 'white', 
                                    cursor: 'pointer',
                                    fontWeight: 600,
                                    minWidth: 150
                                }}
                            >
                                <option value="todos">Filtrar por: Todos</option>
                                <option value="producaoId">ID Projeto</option>
                                <option value="contratoId">Contrato ID</option>
                                <option value="oportunidadeId">Oportunidade ID</option>
                                <option value="titulo">Título</option>
                                <option value="clienteId">Cliente ID</option>
                                <option value="vendaId">Venda ID</option>
                            </select>
                        </div>

                        {loadingProducoes ? (
                            <div style={{ textAlign: 'center', padding: 40, color: '#666' }}>Carregando projetos...</div>
                        ) : producoesFinalizadas.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: 40, color: '#666' }}>Nenhum projeto finalizado dentro da garantia encontrado.<br /><span style={{ fontSize: 13 }}>Garantia e manutenção só podem ser abertas para projetos finalizados, dentro do prazo de garantia.</span></div>
                        ) : (
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
                                {producoesFinalizadas.map((producao, idx) => {
                                    const producaoId = producao.producaoId || producao.ProducaoId;
                                    const contratoId = producao.contratosId || producao.ContratosId;
                                    const oportunidadeId = producao.oportunidadeId || producao.OportunidadeId;
                                    const titulo = producao.oportunidadeTitulo || producao.OportunidadeTitulo || 'Sem título';
                                    const status = producao.status || producao.Status || 'N/A';
                                    const clienteId = producao.clienteId || producao.ClienteId;
                                    const vendaId = producao.vendaId || producao.VendaId;

                                    return (
                                        <div
                                            key={producaoId || idx}
                                            onClick={() => selecionarProducao(producao)}
                                            style={{
                                                padding: 16,
                                                border: 'none',
                                                borderRadius: 8,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s',
                                                backgroundColor: '#fafafa'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.border = '2px solid rgb(235, 133, 0)';
                                                e.currentTarget.style.backgroundColor = '#fff8f0';
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.border = 'none';
                                                e.currentTarget.style.backgroundColor = '#fafafa';
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = 'none';
                                            }}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <span style={{ fontSize: 12, fontWeight: 700, color: 'rgb(235, 133, 0)' }}>ID: {producaoId}</span>
                                                    <span style={{ 
                                                        fontSize: 11, 
                                                        padding: '2px 8px', 
                                                        borderRadius: 10, 
                                                        backgroundColor: status === 'Concluído' ? '#e6f4ea' : status === 'Em Andamento' ? '#e3f2fd' : '#fff8e1',
                                                        color: status === 'Concluído' ? '#1e8e3e' : status === 'Em Andamento' ? '#1565c0' : '#f9a825',
                                                        fontWeight: 600
                                                    }}>
                                                        {status}
                                                    </span>
                                                </div>
                                                <div style={{ fontSize: 14, fontWeight: 600, color: '#333' }}>{titulo}</div>
                                                <div style={{ fontSize: 12, color: '#666', display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                    {contratoId && <span>Contrato: {contratoId}</span>}
                                                    {oportunidadeId && <span>Oportunidade: {oportunidadeId}</span>}
                                                    {clienteId && <span>Cliente: {clienteId}</span>}
                                                    {vendaId && <span>Venda: {vendaId}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Modal Adicionar Responsável */}
            {/* Concluir garantia: horas reais de cada responsável */}
            {conclusaoPendente && (
                <PopupHorasReais
                    titulo="Concluir garantia: horas reais dos responsáveis"
                    responsaveis={responsaveisGarantia.map(r => ({
                        id: r.id || r.responsaveisId || r.ResponsaveisId,
                        nome: r.nome || r.Nome,
                        horasPrevistas: r.horasPrevistas ?? r.HorasPrevistas,
                        horasReais: r.horasReais ?? r.HorasReais
                    }))}
                    onCancelar={() => setConclusaoPendente(null)}
                    onConfirmar={(horas) => {
                        const dados = conclusaoPendente;
                        horasReaisConclusaoRef.current = horas;
                        setConclusaoPendente(null);
                        setTimeout(() => handleSubmitGarantia(dados), 0);
                    }}
                />
            )}

            {adicionarRespAberto && (
                <div className="modal-overlay" onClick={() => setAdicionarRespAberto(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 95030 }}>
                    <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: '92%', maxWidth: 500, background: '#fff', borderRadius: 12, padding: 20 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                            <h3 style={{ margin: 0, color: 'rgb(235, 133, 0)' }}>Adicionar Responsável</h3>
                            <button onClick={() => setAdicionarRespAberto(false)} aria-label="Fechar" title="Fechar" style={{ backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: '50%', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, cursor: 'pointer' }}>×</button>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Responsável *</label>
                                <select
                                    value={novoResponsavel.responsavelId}
                                    onChange={(e) => setNovoResponsavel({ ...novoResponsavel, responsavelId: e.target.value })}
                                    style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }}
                                >
                                    <option value="">Selecione uma pessoa</option>
                                    {pessoas.map((p, idx) => (
                                        <option key={p.id || p.Id || idx} value={p.id || p.Id}>
                                            {p.nome || p.Nome}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div style={{ display: 'flex', gap: 8 }}>
                                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                    <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Horas Previstas</label>
                                    <input
                                        type="number"
                                        step="0.25"
                                        min="0"
                                        value={novoResponsavel.horasPrevistas}
                                        onChange={(e) => setNovoResponsavel({ ...novoResponsavel, horasPrevistas: e.target.value })}
                                        style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }}
                                        title="As horas reais são lançadas ao concluir a garantia"
                                    />
                                </div>
                            </div>
                            <button
                                type="button"
                                onClick={() => setNovoPessoaAberto(true)}
                                style={{ alignSelf: 'flex-start', padding: '8px 14px', backgroundColor: '#fff', color: 'rgb(235, 133, 0)', border: '1px solid rgb(235, 133, 0)', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}
                            >
                                Adicionar nova pessoa
                            </button>
                        </div>

                        <div style={{ marginTop: 20, display: 'flex', gap: 10, justifyContent: 'center' }}>
                            <button
                                onClick={handleAdicionarResponsavel}
                                    style={{ padding: '12px 30px', backgroundColor: 'rgb(235, 133, 0)', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
                            >
                                Adicionar
                            </button>
                            <button
                                onClick={() => setAdicionarRespAberto(false)}
                                style={{ padding: '12px 30px', backgroundColor: '#ccc', color: '#333', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Criar Nova Pessoa (para garantir paridade com Manutenção) */}
            {novoPessoaAberto && (
                <div className="modal-overlay" onClick={() => setNovoPessoaAberto(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 95030 }}>
                    <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: '92%', maxWidth: 500, background: '#fff', borderRadius: 12, padding: 20 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                            <h3 style={{ margin: 0, color: 'rgb(235, 133, 0)' }}>Adicionar Nova Pessoa</h3>
                            <button onClick={() => setNovoPessoaAberto(false)} aria-label="Fechar" title="Fechar" style={{ backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: '50%', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, cursor: 'pointer' }}>×</button>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Nome *</label>
                                <input
                                    value={novaPessoa.nome}
                                    onChange={(e) => setNovaPessoa({ ...novaPessoa, nome: e.target.value })}
                                    style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }}
                                />
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Custo/Hora (R$)</label>
                                <input
                                    value={novaPessoa.custoHora}
                                    onChange={(e) => setNovaPessoa({ ...novaPessoa, custoHora: e.target.value })}
                                    type="number"
                                    step="0.01"
                                    style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }}
                                />
                            </div>
                        </div>

                        <div style={{ marginTop: 20, display: 'flex', gap: 10, justifyContent: 'center' }}>
                            <button
                                onClick={async () => {
                                    if (!novaPessoa.nome || !novaPessoa.nome.trim()) {
                                        alert('Nome é obrigatório');
                                        return;
                                    }
                                    try {
                                        const payload = {
                                            id: 0,
                                            nome: novaPessoa.nome,
                                            custoHora: novaPessoa.custoHora ? parseFloat(novaPessoa.custoHora) : 0
                                        };
                                        await apiCall(BASE_URLS_PESSOA, '', 'POST', payload);
                                        alert('Pessoa criada com sucesso!');
                                        setNovoPessoaAberto(false);
                                        setNovaPessoa({ nome: '', custoHora: '' });
                                        await fetchPessoas();
                                    } catch (err) {
                                        console.error('Erro ao criar pessoa:', err);
                                        alert('Erro ao criar pessoa: ' + (err.message || err));
                                    }
                                }}
                                style={{ padding: '12px 30px', backgroundColor: 'rgb(235, 133, 0)', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
                            >
                                Salvar
                            </button>
                            <button
                                onClick={() => {
                                    setNovoPessoaAberto(false);
                                    setNovaPessoa({ nome: '', custoHora: '' });
                                }}
                                style={{ padding: '12px 30px', backgroundColor: '#ccc', color: '#333', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <LoadingOverlay isLoading={loading} message="Processando..." />
        </div>
    );
}

export default GarantiaDropdown;
